import camelcaseKeys from "camelcase-keys";

class Profile {
  userId: string;

  email: string;

  public static fromJSON(data: Record<string, any>): Profile {
    const { userId, email } = camelcaseKeys(data) as Record<string, any>;

    const profile = new Profile();
    profile.userId = userId;
    profile.email = email;

    return profile;
  }
}

export default Profile;
